import { useState, useEffect } from 'react';
import { useTheme } from '../hooks/useTheme';

interface LoadingSpinnerProps {
  message?: string;
  timeout?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading…',
  timeout = 5000,
}) => {
  const { isDarkMode } = useTheme();
  const [showTimeoutMessage, setShowTimeoutMessage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowTimeoutMessage(true);
    }, timeout);

    return () => clearTimeout(timer);
  }, [timeout]);

  return (
    <div
      className={`theme-shell flex min-h-screen flex-col items-center justify-center px-4 ${isDarkMode ? 'dark' : ''}`}
    >
      <div className="glass-panel flex max-w-sm flex-col items-center gap-5 px-10 py-12 text-center">
        <img src="/MedoBillLogo.png" alt="" className="h-11 w-11 object-contain opacity-95" />
        <div
          className="h-10 w-10 rounded-full border-2 border-theme-border border-t-theme-accent motion-safe:animate-spin"
          aria-hidden
        />
        <p className="text-sm text-theme-text-muted">{message}</p>
        {showTimeoutMessage ? (
          <p className="text-xs text-theme-text-muted">
            Taking longer than expected. Check your connection and try again.
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default LoadingSpinner;
